export default __webpack_public_path__ + "static/signage2-437ddda7787ec580ccc01a677f22d531.webp";